import type { ComponentPropsWithoutRef, ElementType, ReactNode } from "react";
import { cn } from "@/lib/utils";

type ParticipantFlowPanelProps<T extends ElementType = "section"> = {
  as?: T;
  children: ReactNode;
  className?: string;
} & Omit<ComponentPropsWithoutRef<T>, "as" | "children" | "className">;

export default function ParticipantFlowPanel<T extends ElementType = "section">({
  as,
  children,
  className,
  style,
  ...props
}: ParticipantFlowPanelProps<T>) {
  const Component = as ?? "section";

  return (
    <Component
      className={cn(
        "theme-surface-panel flex min-h-full flex-col rounded-[var(--session-section-radius-xl)] border px-[clamp(1rem,1.8vw,1.75rem)] py-[clamp(1rem,1.8vw,1.75rem)]",
        className
      )}
      style={style}
      {...props}
    >
      {children}
    </Component>
  );
}
